import type { SVGProps } from "react";
export interface LayersOffIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function LayersOffIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: LayersOffIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M19.669 11.09a1.125 1.125 0 0 1 1.483-.57 1.612 1.612 0 0 1 .229 2.838l-.229.123-1.785.793a1.126 1.126 0 0 1-.914-2.055l1.132-.504a1.1 1.1 0 0 1 .084-.624Zm.826.909-.255.577.457-1.028-.202.45Zm-10.086-9.83a4.47 4.47 0 0 1 3.4.089l7.343 3.262.229.121c.993.63.992 2.087 0 2.718l-.229.121-5.248 2.332-.107.041a1.125 1.125 0 0 1-.806-2.097l3.952-1.757-6.048-2.685a2.22 2.22 0 0 0-1.573-.083l-.217.083-1.176.522-.109.042a1.126 1.126 0 0 1-.805-2.097l1.178-.523zm-8.204.036a1.125 1.125 0 0 1 1.506-.078l.085.078 18 18 .077.085a1.125 1.125 0 0 1-1.583 1.583l-.085-.078-2.004-2.004-4.392 1.952a4.47 4.47 0 0 1-3.4.089l-.218-.09-7.343-3.262a1.613 1.613 0 0 1 0-2.96l.107-.043a1.125 1.125 0 0 1 1.459 1.237l6.691 2.972.217.084a2.22 2.22 0 0 0 1.573-.084l3.6-1.6-1.756-1.756-.93.413a4.47 4.47 0 0 1-3.4.09l-.218-.09-7.343-3.262a1.614 1.614 0 0 1 0-2.962l.107-.041a1.123 1.123 0 0 1 1.459 1.236l6.691 2.973.217.082a2.22 2.22 0 0 0 1.573-.082l.138-.063-2.917-2.915L2.848 8.48a1.613 1.613 0 0 1 0-2.96l.748-.333-1.391-1.392-.078-.085a1.125 1.125 0 0 1 .078-1.505M5.057 7l.634.282-.391-.39z"
      />
    </svg>
  );
}
